<template>
    <!-- Banner de incio -->
    <div class="bannerHome">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <h4>Jun 29, 2025</h4>
                <h1>Carrera de Obstáculos</h1>
            </div>
            <div class="colImg col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FJiloMagico.jpg?alt=media&token=2e2974b6-06ff-45e5-aa9f-6a6de2ef777a"
                    alt="Logo Banner" class="imgHome2 img-fluid" />
            </div>
        </div>
    </div>

    <main class="container mt-3 text-center">
        <div class="container">

            <!-- Seccion Principal -->
            <section>
                <div class="row mt-4">
                    <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                        <!-- Card de Información -->
                        <div class="card cardInfo">
                            <img class="logoCard img-fluid" src="@/assets/images/2025/logo2025.jpeg" alt="Logo" />

                            <div class="card-body">
                                <h4 class="textTitle">Reto entre Senderos</h4>
                                <h5 class="textSubtitle">Canalejas Jilotepec - Estado de México</h5>

                                <ul class="list-group mt-3">
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Fecha:</strong> <span
                                            class="textRegularBodyCard">Domingo 29 de junio 2025</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Lugar:</strong> <span
                                            class="textRegularBodyCard">Parque el Llano Canalejas</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Hora de Inicio:</strong> <span
                                            class="textRegularBodyCard">7:00 AM</span>
                                    </li>
                                    <li class="list-group-item">
                                        <strong class="textBoldBodyCard">Distancias:</strong> <span
                                            class="textRegularBodyCard">5 y 11 Km</span>
                                    </li>
                                </ul>

                                <button class="fillButton">
                                    <a href="" style="color: white; text-decoration: none;">Inscripción finalizada</a>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Bienvenida -->
                    <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 mt-5 cardBienvenida">
                        <img class="imgBanner img-fluid"
                            src="@/assets/images/logo_principal.png"
                            alt="Logo" />

                        <h2 class="textBoldBodyCard mt-3">¡Corre, disfruta y vive la naturaleza en el Parque <br> El
                            Llano Canalejas!</h2>
                        <p class="textRegularBodyCard mt-3">
                            "Un recorrido que pondrá a prueba tu cuerpo, mente y espíritu. Rodeado de paisajes que te
                            robarán el aliento y obstáculos que sacarán lo mejor de ti."
                        </p>
                    </div>
                </div>
            </section>

            <!-- Sección de Información -->
            <section id="informacion">
                <h2 class="sectionsTitle">Información de la carrera</h2>

                <div class="row mt-5">
                    <!-- Información Obstáculos-->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-5 mb-lg-0">
                        <div class="card sectionObstaculos">

                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/2025/velocidad.png" alt="velocidad">
                                </div>
                            </div>
                            <br>
                            <div class="card-body mt-3">
                                <h5 class="textBoldBodyCard colorPrincipal">5 y 11Km con Obstáculos</h5>

                                <div class="row mt-3">
                                    <div class="col-6">
                                        <h5 class="textBoldBodyCard">Trail Mixto</h5>
                                        <ul class="list-group" style="list-style-type: none;">
                                            <li>Tierra</li>
                                            <li>Lodo</li>
                                            <li>Agua</li>
                                            <li>Arena</li>
                                        </ul>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="textBoldBodyCard">Obstáculos</h5>
                                        <ul class="list-group" style="list-style-type: none;">
                                            <li>Muro</li>
                                            <li>Cuerda</li>
                                            <li>Llantas</li>
                                            <li>Charcos de Lodo</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Información Meta -->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card sectionObstaculos">
                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/2025/terminar.png" alt="velocidad">
                                </div>
                            </div>
                            <br>

                            <div class="card-body mt-3">
                                <h5 class="textBoldBodyCard colorPrincipal">Salida y Meta</h5>

                                <h5 class="textBoldBodyCard mt-4">Parque El Llano, Canalejas, <br> Jilotepec, Estado de
                                    México</h5>

                                <h5 class="textRegularBodyCard mt-5">Buscalo en Google Maps como:</h5>
                                <h5 class="textBoldBodyCard mb-2">Bosque de Canalejas</h5>

                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <!-- Sección de Precios y Fases -->
            <section id="registro">
                <h2 class="sectionsTitle">Costos de Inscripción</h2>

                <div class="row row-cols-1 row-cols-md-3 mb-4 mb-lg-0 mt-4">

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 1</h4>
                                <h5 class="card-fase-subtitle-style">22 de abril - 22 de mayo</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$300 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Playera conmemorativa</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 2</h4>
                                <h5 class="card-fase-subtitle-style">23 de mayo - 22 de junio</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$350 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Playera conmemorativa</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Fase 3</h4>
                                <h5 class="card-fase-subtitle-style">23 de junio - 29 de junio</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$400 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Playera conmemorativa</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 mt-0 mt-lg-4 ">
                        <div class="card">
                            <div class="card-header card-fase-header">
                                <h4 class="card-fase-title-style">Ultima Fase</h4>
                                <h5 class="card-fase-subtitle-style">Dia del Evento</h5>
                            </div>

                            <div class="card-fase-body mt-4">
                                <h4 class="textTitle mb-0">$500 MXM</h4>
                                <h5 class="textSubtitle mt-0">Por persona</h5>

                                <h4 class="card-fase-subtitle-style2 mt-4">¿Que incluye?</h4>
                                <ul class="list-group list-fase-includes">
                                    <li class="textSubtitle">Medalla</li>
                                    <li class="textSubtitle">Playera conmemorativa</li>
                                    <li class="textSubtitle">Pulsera de indentificación</li>
                                    <li class="textSubtitle mb-4">Refrigerio post Carrera</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <!-- Sección Kids -->
            <section>
                <h2 class="sectionsTitle">XHIDENXI - Aventura Kids</h2>
                <p class="textSubtitle">"Una carrera de obstáculos en medio del bosque pensada para los más peques,
                    donde cada paso es una aventura y cada reto, una oportunidad de crecer."</p>

                <div class="full-center mt-4">
                    <div class="card sectionObstaculos p-4">
                        <div class="d-flex align-items-center mb-3">
                            <h4 class="textTitle mb-0">Detalles de la Carrera Kids</h4>
                        </div>
                        <div class="card-body mt-2">
                            <div class="row">
                                <div class="col-md-6 mb-3 mb-md-0">
                                    <div class="mb-3">
                                        <h6 class="textBoldBodyCard colorPrincipal mb-1"><i
                                                class="fas fa-flag-checkered me-2"></i>Disparo de salida</h6>
                                        <span class="textSubtitle">10:00 am</span>
                                    </div>
                                    <div>
                                        <h6 class="textBoldBodyCard colorPrincipal mb-1"><i
                                                class="fas fa-route me-2"></i>Distancia</h6>
                                        <span class="textSubtitle">2.5 Km</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <h6 class="textBoldBodyCard colorPrincipal mb-1"><i
                                                class="fas fa-map-marker-alt me-2"></i>Salida y Meta</h6>
                                        <span class="textSubtitle">Parque El Llano, Canalejas,<br>Jilotepec, Estado de
                                            México</span>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="d-flex align-items-center mb-2">
                                <i class="fas fa-user-friends fa-lg me-2 colorPrincipal"></i>
                                <span class="textSubtitle">Pueden ser acompañados por un adulto durante el
                                    recorrido.</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-file-signature fa-lg me-2 colorPrincipal"></i>
                                <span class="textSubtitle"><b>*Requisito:</b> Responsiva firmada</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-4">
                    <div class="card-header card-fase-header text-center">
                        <h4 class="card-fase-title-style mb-0">Fases de Inscripción Kids</h4>
                    </div>
                    <div class="card-fase-body p-4">
                        <div class="row g-4">
                            <!-- Preventa -->
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="card sectionObstaculos h-100 border-0">
                                    <div class="card-body text-center">
                                        <div class="mb-3">
                                            <span class="badge rounded-pill bg-success px-3 py-2 fs-6">Preventa</span>
                                        </div>
                                        <h2 class="textTitle mb-1" style="color:#2e7d32;">$300 MXN</h2>
                                        <p class="textSubtitle mb-3">Hasta 22 de junio</p>
                                        <h5 class="card-fase-subtitle-style2 mt-3 mb-2">Incluye:</h5>
                                        <ul class="list-group list-unstyled mb-3">
                                            <li class="textSubtitle"><i
                                                    class="fas fa-medal me-2 colorPrincipal"></i>Medalla</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-tshirt me-2 colorPrincipal"></i>Playera</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-id-badge me-2 colorPrincipal"></i>Pulsera de
                                                identificación</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-tree me-2 colorPrincipal"></i>Acceso al parque</li>
                                        </ul>
                                        <!--<span class="badge bg-light text-dark px-2 py-1">Cupo limitado</span>-->
                                    </div>
                                </div>
                            </div>
                            <!-- Día del Evento -->
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="card sectionObstaculos h-100 border-0">
                                    <div class="card-body text-center">
                                        <div class="mb-3">
                                            <span class="badge rounded-pill bg-warning text-dark px-3 py-2 fs-6">Día del
                                                Evento</span>
                                        </div>
                                        <h2 class="textTitle mb-1" style="color:#f9a825;">$400 MXN</h2>
                                        <p class="textSubtitle mb-3">23 al 29 de junio</p>
                                        <h5 class="card-fase-subtitle-style2 mt-3 mb-2">Incluye:</h5>
                                        <ul class="list-group list-unstyled mb-3">
                                            <li class="textSubtitle"><i
                                                    class="fas fa-medal me-2 colorPrincipal"></i>Medalla</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-tshirt me-2 colorPrincipal"></i>Playera</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-id-badge me-2 colorPrincipal"></i>Pulsera de
                                                identificación</li>
                                            <li class="textSubtitle"><i
                                                    class="fas fa-tree me-2 colorPrincipal"></i>Acceso al parque</li>
                                        </ul>
                                        <!--<span class="badge bg-light text-dark px-2 py-1">Sujeto a disponibilidad</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="full-center mt-4">
                    <div class="card sectionObstaculos p-4">
                        <div class="d-flex align-items-center mb-3">
                            <h4 class="textTitle mb-0">Categorías de la Carrera Kids</h4>
                        </div>
                        <div class="card-body mt-2">
                            <div class="row g-4">
                                <!-- Categoría por grados escolares -->
                                <div class="col-md-6">
                                    <div class="card border-0 shadow-sm h-100 bg-light">
                                        <div class="card-body text-center">
                                            <div class="mb-3">
                                                <span class="badge rounded-pill bg-primary fs-6 px-3 py-2">Primaria
                                                    Baja</span>
                                            </div>
                                            <h5 class="textBoldBodyCard colorPrincipal mb-2"><i
                                                    class="fas fa-child me-2"></i>1° a 3°</h5>
                                            <p class="textSubtitle mb-0">Niños y niñas de 1° a 3° de primaria</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- Categoría por grados escolares -->
                                <div class="col-md-6">
                                    <div class="card border-0 shadow-sm h-100 bg-light">
                                        <div class="card-body text-center">
                                            <div class="mb-3">
                                                <span class="badge rounded-pill bg-success fs-6 px-3 py-2">Primaria
                                                    Alta</span>
                                            </div>
                                            <h5 class="textBoldBodyCard colorPrincipal mb-2"><i
                                                    class="fas fa-user-graduate me-2"></i>4° a 6°</h5>
                                            <p class="textSubtitle mb-0">Niños y niñas de 4° a 6° de primaria</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="d-flex flex-column align-items-center">
                                <span class="textSubtitle text-center" style="font-size: 1.1rem;">
                                    ¡Atrévete a descubrir lo que llevas dentro!<br>
                                    <span class="fw-bold">Donde empieza la aventura</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <!-- Sección de ¿Como inscribirse? -->
            <section>
                <h2 class="sectionsTitle"> ¿Como Inscribirte?</h2>

                <div class="card p-4 sectionObstaculos mt-4">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 mb-md-0">
                            <!-- Lado izquierdo -->
                            <div class="card sectionObstaculos mt-4">
                                <div class="circle">
                                    <div class="icon">
                                        <img src="@/assets/images/2025/uno.png" alt="velocidad">
                                    </div>
                                </div>

                                <div class="card-body mt-4">
                                    <div class="text-center">
                                        <h5 class="card-fase-subtitle-style2" style="color: #567067;">Realiza tu pago:
                                        </h5>
                                        <p class="textSubtitle">Elige tu forma favorita</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Efectivo en Gimnasio El Terreno</h6>
                                        <p class="textSubtitle">Horario de Atención: lunes a viernes - 5pm - 8pm</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Transferencia bancaria</h6>
                                        <p class="textSubtitle">7289 6900 0028 945078</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Depósito OXXO</h6>
                                        <p class="textSubtitle">2242 1704 2012 2648</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-0 mb-lg-0">
                            <div class="card sectionObstaculos mt-4">
                                <div class="circle">
                                    <div class="icon">
                                        <img src="@/assets/images/2025/dos.png" alt="velocidad">
                                    </div>
                                </div>

                                <div class="card-body mt-4">
                                    <div class="text-center">
                                        <h5 class="card-fase-subtitle-style2" style="color: #567067;">Envia tu
                                            comprobante:</h5>
                                        <p class="textSubtitle">Al número: 5540861907</p>

                                        <h6 class="card-fase-subtitle-style2 mt-4">Con los siguientes datos:</h6>
                                        <p class="textSubtitle mb-2">Nombre Completo</p>
                                        <p class="textSubtitle mb-2">Talla de playera</p>
                                        <p class="textSubtitle mb-2">Distancia elegida (5 o 11KM)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Sección de Beneficios -->
            <section>
                <h2 class="sectionsTitle">Beneficios</h2>

                <p class="textSubtitle mb-1">Al adquirir tu kit de participación, no solo te unes a una increíble
                    carrera</p>
                <p class="textSubtitle">¡También obtienes acceso total al parque durante todo el día!</p>

                <div class="full-center mt-4">
                    <div class="gradient-bg shadow-lg p-4">
                        <h4 class="fw-bold mb-4">Actividades para disfrutar en familia:</h4>
                        <div class="row g-3">
                            <div class="col-12 d-flex align-items-start">
                                <div class="icon-circle flex-shrink-0 me-3 fs-2"
                                    style="min-width: 2.5rem; text-align:center;">🌲</div>
                                <div class="feature-text"><strong>Picnic en familia:</strong> Áreas verdes, mesas y
                                    asadores para disfrutar de un día al aire libre.</div>
                            </div>
                            <div class="col-12 d-flex align-items-start">
                                <div class="icon-circle flex-shrink-0 me-3 fs-2"
                                    style="min-width: 2.5rem; text-align:center;">⛺</div>
                                <div class="feature-text"><strong>Campamento:</strong> Quédate a acampar y pasa una
                                    noche bajo las estrellas.</div>
                            </div>
                            <div class="col-12 d-flex align-items-start">
                                <div class="icon-circle flex-shrink-0 me-3 fs-2"
                                    style="min-width: 2.5rem; text-align:center;">🚴‍♂️</div>
                                <div class="feature-text"><strong>Ciclismo:</strong> Rutas naturales ideales para rodar
                                    entre el bosque.</div>
                            </div>
                            <div class="col-12 d-flex align-items-start">
                                <div class="icon-circle flex-shrink-0 me-3 fs-2"
                                    style="min-width: 2.5rem; text-align:center;">🚶‍♀️</div>
                                <div class="feature-text"><strong>Senderismo:</strong> Conecta con la naturaleza
                                    recorriendo bellos paisajes.</div>
                            </div>
                            <div class="col-12 d-flex align-items-start">
                                <div class="icon-circle flex-shrink-0 me-3 fs-2"
                                    style="min-width: 2.5rem; text-align:center;">🏛️</div>
                                <div class="feature-text"><strong>Visita cultural:</strong> Conoce el Santuario de la
                                    Virgen de las Piedritas, joya del siglo XIX.</div>
                            </div>
                        </div>
                        <p class="mt-4 fst-italic text-white-50">¡Haz que tu carrera se convierta en una experiencia
                            completa en contacto con la naturaleza!</p>
                    </div>
                </div>
            </section>

            <!-- Sección Redes -->
            <section>
                <h2 class="sectionsTitle mb-4">Síguenos en nuestras redes sociales y entérate de todas nuestras
                    novedades:</h2>

                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card sectionObstaculos mt-4">
                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/social/facebook.png" alt="velocidad">
                                </div>
                            </div>

                            <div class="card-body mt-4">
                                <div class="text-center">
                                    <h6 class="card-fase-subtitle-style2 mt-4">Facebook - Carrera XHIDENXI</h6>
                                    <button class="fillButton">
                                        <a href="https://www.facebook.com/share/1M7Ey93VAa/?mibextid=wwXIfr"
                                            style="color: white; text-decoration: none;">Seguir</a>
                                    </button>

                                    <h6 class="card-fase-subtitle-style2 mt-4">Facebook - El Terreno Gym</h6>
                                    <button class="fillButton">
                                        <a href="https://www.facebook.com/profile.php?id=100063960199044"
                                            style="color: white; text-decoration: none;">Seguir</a>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card sectionObstaculos mt-4">
                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/social/instagram.png" alt="velocidad">
                                </div>
                            </div>

                            <div class="card-body mt-4">
                                <div class="text-center">
                                    <h6 class="card-fase-subtitle-style2 mt-4">Instagram - Carrera XHIDENXI</h6>
                                    <button class="fillButton">
                                        <a href="https://www.instagram.com/xhidenxi/"
                                            style="color: white; text-decoration: none;">Seguir</a>
                                    </button>

                                    <h6 class="card-fase-subtitle-style2 mt-4">Instagram - El Terreno Gym</h6>
                                    <button class="fillButton">
                                        <a href="https://www.instagram.com/crossfit_gym_box_el_terreno/"
                                            style="color: white; text-decoration: none;">Seguir</a>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                        <div class="card sectionObstaculos mt-4">
                            <div class="circle">
                                <div class="icon">
                                    <img src="@/assets/images/social/whatsapp.png" alt="velocidad">
                                </div>
                            </div>

                            <div class="card-body mt-4">
                                <div class="text-center">
                                    <h6 class="card-fase-subtitle-style2 mt-4">WhatsApp - Grupo Carrera XHIDENXI</h6>
                                    <button class="fillButton">
                                        <a href="https://chat.whatsapp.com/GQJxrYTq3pJ6cGiQFQccrJ"
                                            style="color: white; text-decoration: none;">Unirte</a>
                                    </button>

                                    <h6 class="card-fase-subtitle-style2 mt-4">WhatsApp - El Terreno Gym</h6>
                                    <button class="fillButton">
                                        <a href="https://api.whatsapp.com/send/?phone=525540861907&text&type=phone_number&app_absent=0"
                                            style="color: white; text-decoration: none;">Contactar</a>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </main>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  document.body.style.backgroundColor = '#F6F6F6'
})

onUnmounted(() => {
  document.body.style.backgroundColor = '#F6F1EC'
})
</script>

<style scoped>
#navModified {
    background: #1E7BC1;
}

#navModified .nav-link {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 25px;
}

.sponsors h2 {
    font-size: 2rem;
    color: #333;
}

.sponsor-card {
    background: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.sponsor-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.sponsor-card img {
    max-height: 100px;
    object-fit: contain;
}

body {
    background-color: #F6F6F6;
    margin: 0;
}

#navModified {
    background: #567067;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

#navModified .nav-link {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    color: white;
    font-size: 22px;
}

.logo {
    display: flex;
    align-items: center;
}

.logo img {
    height: 80px;
    margin-right: 10px;
}

.logo span {
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin-right: 10px;
}

#info ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#info ul li {
    margin: 0 15px;
}

#info ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

/* Estilo para el banner */
.bannerHome {
    background-color: #303030;
    padding: 16px;
}

.bannerHome h4 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: normal;
    color: #fff;
    font-size: 2rem;
    margin: 0 0 0 0;
}

.bannerHome h1 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    font-size: 5rem;
    color: #fff;
}

.bannerHome img {
    margin: 0 auto;
    width: 190px;
    height: 190px;
}

.bannerHome .imgHome1,
.bannerHome .imgHome2 {
    border-radius: 120px;
}

/* Colores de texto */
.colorPrincipal {
    color: #567067;
}

/* Textos de las secciones*/
.sectionsTitle {
    margin-top: 60px;
    font-family: "GYMZain", sans-serif;
    font-size: 33px;
    font-weight: bold;
}

/* Estilo para el card Principal */
.cardInfo {
    border-color: #DDDDDD;
    padding-top: 15px;
    padding-bottom: 15px;
}

.textTitle {
    font-family: "GYMZain", sans-serif;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    margin: 0;
}

.textSubtitle {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    line-height: 1;
    margin: 0;
}

.textRegularBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    margin: 0;
}

.textBoldBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.fillButton {
    background-color: #567067;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 8px 20%;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    margin-top: 20px;
}

.logoCard {
    margin-top: 15px;
    border-radius: 120px;
    height: 180px;
    width: 180px;
    margin: 0 auto;
    object-fit: cover;
}

.imgBanner {
    margin: 0 auto;
    height: 180px;
    width: 180px;
}

.cardBienvenida {
    padding: 16px;
}

.sectionObstaculos {
    position: relative;
    overflow: visible;
}

.sectionObstaculos .circle {
    width: 70px;
    height: 70px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

.sectionObstaculos .circle .icon img {
    width: 35px;
    height: auto;
}

.list-group li {
    padding: 5px;
}

/* Estilo para el card de precios */
#registro ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#registro ul li {
    margin: 0 15px;
}

#registro ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

.card-fase-header {
    background-color: #567067;
    padding: 10px;
}

.card-fase-title-style {
    font-family: "GYMZain", sans-serif;
    font-size: 26px;
    font-weight: bold;
    color: white;
    margin: 0;
}

.card-fase-subtitle-style {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: normal;
    color: white;
    margin: 0;
}

.card-fase-subtitle-style2 {
    font-family: "GYMZain", sans-serif;
    font-size: 22px;
    font-weight: bold;
    margin: 0;
}

.full-center {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
}

.gradient-bg {
    background: linear-gradient(to right, #2e473a, #6b8f89);
    color: white;
    border-radius: 1rem;
    overflow: hidden;
    max-width: 800px;
}

.icon-circle {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
}

.feature-text {
    font-size: 0.95rem;
}
</style>
